import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootGridButton: {
        position: 'fixed',
        right: '18%',
        bottom: '5%',
        zIndex: '1',
    },
    rootGridContent: {
        padding: '10px 12px',
        width: '100%',
    },
    rootTitle: {
        fontFamily: themeCommon.RobotoBold,
        margin: '20px 0 30px',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize28px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize24px,
        },
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
            fontSize: themeCommon.fontSize20px,
            marginTop: '0 !important',
        },
    },
    btnOnTop: {
        color: themeCommon.lightBlue,
        background: 'white',
        marginBottom: '10px',
    },
    btnComeBack: {
        color: 'white',
        background: themeCommon.lightBlue,
    },
    btnCommon: {
        height: '50px !important',
        width: '50px',
        borderRadius: '50%',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
        '& > span': {
            paddingLeft: 'unset',
            paddingRight: 'unset',
            paddingTop: '3px',
        },

        [theme.breakpoints.down('lg')]: {
            '& > span > img': {
                width: '30px',
            },
            height: '45px !important',
            width: '45px',
        },
        [theme.breakpoints.down('md')]: {
            '& > span > img': {
                width: '25px',
            },
            height: '40px !important',
            width: '40px',
        },
        [theme.breakpoints.down('sm')]: {
            '& > span > img': {
                width: '20px',
            },
            height: '35px !important',
            width: '35px',
        },
    },
}), {
    name: 'NofiticationHeadContainer',
    index: 1,
})

export default useStyles